import React from 'react';
export const ComparisonSection = () => {
  const rows = ['Tenés una planificación organizada para trabajar de 1.º a 7.º grado.', 'El entusiasmo por el Mundial se convierte en lectura, escritura, cálculo e investigación.', 'Contás con tablas, gráficos, estadísticas, promedios y porcentajes listos para enseñar.', 'Ambientás el aula sin perder horas buscando recursos en diferentes páginas.', 'Cerrás el proyecto reconociendo aprendizajes, valores, esfuerzo y compañerismo.'];
  return <section className="bg-familia-lightBg py-10 md:py-16 px-4 md:px-6 text-familia-darkText" data-id="element-42">
      <div className="max-w-4xl mx-auto w-[92%] md:w-full" data-id="element-43">
        <div className="text-center mb-8 md:mb-12" data-id="element-44">
          <h2 className="text-[20px] sm:text-2xl md:text-4xl font-display font-extrabold mb-4 leading-tight text-familia-bg" data-id="element-45">
            ¿Cuánto cuesta seguir planificando desde cero?
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-46">
          {rows.map((row, i) => <div key={i} className="bg-white border border-familia-electric/20 p-4 md:p-5 rounded-2xl flex items-start gap-3 shadow-sm hover:shadow-md transition-shadow" data-id="element-47">
              <span className="text-familia-green text-lg shrink-0 mt-0.5" data-id="element-48">
                ✅
              </span>
              <p className="text-familia-darkText text-[13px] sm:text-[14px] md:text-[15px] leading-relaxed font-medium" data-id="element-49">
                <span className="text-familia-electric font-bold block mb-0.5 uppercase text-[10px] tracking-wider" data-id="element-50">
                  Con Mundial en el Aula 360™:
                </span>
                {row}
              </p>
            </div>)}
        </div>

        <div className="mt-10 md:mt-16 text-center max-w-3xl mx-auto" data-id="element-51">
          <p className="text-lg sm:text-xl md:text-2xl font-display font-bold text-familia-bg" data-id="element-52">
            Tus alumnos ya están interesados en el Mundial. Ahora podés
            convertir ese interés en aprendizaje.
          </p>
        </div>
      </div>
    </section>;
};